import { apiGet } from 'shared/services/api/resource';
import { TOURNAMENTS, TOURNAMENT_DETAILS } from 'modules/jogador/tournaments/content';
import { TournamentDetail, TournamentSummary } from 'modules/jogador/tournaments/types';

export function fetchTournaments(): Promise<TournamentSummary[]> {
  return apiGet(TOURNAMENTS, '/tournaments');
}

export function fetchTournamentDetail(tournamentId: string): Promise<TournamentDetail | undefined> {
  return apiGet(TOURNAMENT_DETAILS[tournamentId], `/tournaments/${tournamentId}`);
}
